<template>
  <c-loading-area :loading="loading">
    <v-card-title>
      {{ $t('page.manageFiling.origCourt.stepDetails.title') }}
    </v-card-title>
    <v-card-subtitle>
      {{ $t('page.manageFiling.origCourt.stepDetails.description') }}
    </v-card-subtitle>
    <v-card-text class="pt-2">
      <v-row no-gutters>
        <v-col cols="12">
          <c-text-field
            v-model="bean.department"
            :label="$t('page.manageFiling.origCourt.stepDetails.field.department')"
            maxlength="250"
            key="department"
            outlined
            hide-details="auto"
            aria-describedby="089dc663-b81c-464e-ab77-44a3d727fe87"/>
          <field-description id="089dc663-b81c-464e-ab77-44a3d727fe87"
                             message-key="page.manageFiling.origCourt.stepDetails.field.department.description"/>
        </v-col>
        <v-col cols="12">
          <c-text-field
            v-model="bean.courtReporter"
            :label="$t('page.manageFiling.origCourt.stepDetails.field.courtReporter')"
            maxlength="250"
            key="courtReporter"
            outlined
            hide-details="auto"
            aria-describedby="439c5508-5b54-4dd7-a4a4-3ec96bb26113"/>
          <field-description id="439c5508-5b54-4dd7-a4a4-3ec96bb26113"
                             message-key="page.manageFiling.origCourt.stepDetails.field.courtReporter.description"/>
        </v-col>
        <v-col cols="12">
          <c-text-field
            v-model="bean.dispositionType"
            :label="$t('page.manageFiling.origCourt.stepDetails.field.dispositionType')"
            maxlength="250"
            key="dispositionType"
            outlined
            hide-details="auto"
            aria-describedby="d604843e-6a84-4817-aaff-64d262e60af7"/>
          <field-description id="d604843e-6a84-4817-aaff-64d262e60af7"
                             message-key="page.manageFiling.origCourt.stepDetails.field.dispositionType.description"/>
        </v-col>
        <v-col cols="12">
          <!--label:  -->
          <c-text-field
            v-model="bean.dispositionMethod"
            :label="$t('page.manageFiling.origCourt.stepDetails.field.dispositionMethod')"
            maxlength="250"
            key="dispositionMethod"
            outlined
            hide-details="auto"
            aria-describedby="a07a7cf0-2439-4220-b3f4-a7a4dba619b5"/>
          <field-description id="a07a7cf0-2439-4220-b3f4-a7a4dba619b5"
                             message-key="page.manageFiling.origCourt.stepDetails.field.dispositionMethod.description"/>
        </v-col>
        <v-col cols="12">
          <c-date-picker
            v-model="bean.noticeOfAppealDate"
            :label="$t('page.manageFiling.origCourt.stepDetails.field.noticeOfAppealDate')"
            key="noticeOfAppealDate"
            outlined
            hide-details="auto"
            aria-describedby="31f22802-52d7-441b-bb41-d4131934372b"/>
          <field-description id="31f22802-52d7-441b-bb41-d4131934372b"
                             message-key="page.manageFiling.origCourt.stepDetails.field.noticeOfAppealDate.description"/>
        </v-col>
        <v-col cols="12">
          <c-textarea
            v-model="bean.comments"
            :label="$t('page.manageFiling.origCourt.stepDetails.field.comments')"
            maxlength="2000"
            outlined
            hide-details="auto"
            aria-describedby="f6be62f3-c6f6-4bc8-84e0-0dc51bfda0db"/>
          <field-description id="f6be62f3-c6f6-4bc8-84e0-0dc51bfda0db"
                             message-key="page.manageFiling.origCourt.stepDetails.field.comments.description"/>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="justify-end mt-5">
      <c-btn type="primary" @click="save">
        {{ editing ? $t('global.save') : $t('global.next') }}
      </c-btn>
      <c-btn v-if="!editing" @click="$emit('back')">
        {{ $t('global.back') }}
      </c-btn>
      <c-btn @click="$emit('cancel')">
        {{ $t('global.cancel') }}
      </c-btn>
    </v-card-actions>
  </c-loading-area>
</template>

<script>
import _ from 'lodash';
import WorkflowStepMixin from '@/mixins/workflowStep';

export default {
  mixins: [ WorkflowStepMixin ],
  props: {
    editing: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    validate () {
      this.$cove.validation.clear();
      if (!_.isNil(this.bean.noticeOfAppealDate))
      {
        this.$cove.validation.date.rejectIfInvalid(this.bean.noticeOfAppealDate,
          'page.manageFiling.origCourt.stepDetails.field.noticeOfAppealDate', 'noticeOfAppealDate');
      }
      return !this.$cove.validation.hasErrors();
    },
    save () {
      let isValid = this.validate();
      if (!isValid)
      {
        this.scrollTo(this.CONST.ERROR_CONTAINER_SELECTOR);
      }
      else
      {
        this.$emit('save', this.bean);
      }
    }
  }
};
</script>